import React from "react";
import { Container, Title, Grid, ActionButton, SoonBadge } from "./styles";
import { useQuickActionsViewModel } from "./useQuickActionsViewModel";
import { ReactComponent as PlayCircleIcon } from "../../../../assets/kinologyIcons/svg/play_circle.svg";
import { ReactComponent as PlusCircleIcon } from "../../../../assets/kinologyIcons/svg/plus_circle.svg";
import { ReactComponent as ExtensionIcon } from "../../../../assets/kinologyIcons/svg/extension.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/kinologyIcons/svg/calendar_today.svg";

interface QuickActionsProps {
	openPatientListModal: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({
	openPatientListModal,
}) => {
	const { handleAddPatient } = useQuickActionsViewModel();

	return (
		<Container aria-labelledby="quick-actions-title">
			<Title id="quick-actions-title">Ações rápidas</Title>
			<Grid>
				<ActionButton
					enabledType="green"
					onClick={openPatientListModal}
					type="button"
					aria-label="Nova avaliação"
				>
					<PlayCircleIcon width="18px" height="18px" fill="#00a377" />
					Nova avaliação
				</ActionButton>
				<ActionButton
					enabledType="default"
					onClick={handleAddPatient}
					type="button"
					aria-label="Adicionar Paciente"
				>
					<PlusCircleIcon width="18px" height="18px" fill="#000e4b" />
					Adicionar Paciente
				</ActionButton>
				<ActionButton type="button" aria-disabled="true" tabIndex={-1}>
					<SoonBadge>Em Breve</SoonBadge>
					<ExtensionIcon width="18px" height="18px" />
					Integrações
				</ActionButton>
				<ActionButton type="button" aria-disabled="true" tabIndex={-1}>
					<SoonBadge>Em Breve</SoonBadge>
					<CalendarIcon width="18px" height="18px" />
					Abrir agenda
				</ActionButton>
			</Grid>
		</Container>
	);
};

export default QuickActions;
